import { defineStore } from '@/modules/pinia-hot'
import {
  accountDataResource,
} from '@/services/profile.service'
import { User as BaseUser } from './base/user'
/* eslint-disable */
const id = 'user'

const isAuth = window.isAuth

export const useUserStore = defineStore(id, {
  state: () => ({
    profile: '',
    user: new BaseUser({}, false),
  }),
  getters: {
    getUserInfo: (state) => state.profile,
  },
  actions: {
    async receive() {
      if(!isAuth) return
      try {
        const { data } = await accountDataResource.execute({})
        this.profile = data.item
        this.user = new BaseUser(data.item)
      } catch (e) {
      }
    },
  },
})